import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import {
  Title,
  Container,
  SubTitle,
  ContainerForm,
} from "./forgottenPassword.styled";
import Languages from "../../layouts/commons/header/components/languages";
import { withFormik, Field } from "formik";
import { dataModel, validationDataModel } from "./forgottenPassword.data.form";
import InputText from "../../utils/InputText";

const ForgotPWForm = (props) => {
  const { handleSubmit, onBack } = props;
  const { t } = useTranslation();

  return (
    <div className="login-page row no-margin">
      <div className="col-12">
        <div className="row justify-content-center">
          <div className="col-10 mt-2 d-flex justify-content-end">
            <Languages />
          </div>
        </div>
        <Container className="row justify-content-end align-items-center">
          <div className="col-12 col-md-6 col-lg-6">
            <ContainerForm className="row justify-content-center align-items-center">
              <div className="row justify-content-center">
                <div className="col-12 col-md-10 text-left ps-0 text-center">
                  <Title>{t("forms.provider.forgottenPassword.title")}</Title>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-12 col-md-10 mt-3 mb-2 ps-0 text-center">
                  <SubTitle>
                    {t("forms.provider.forgottenPassword.body")}
                  </SubTitle>
                </div>
              </div>
              <form
                className="form-horizontal bordered-row"
                onSubmit={handleSubmit}
              >
                <div className="row justify-content-center">
                  <div className="col-12 col-md-10">
                    <Field
                      id="email"
                      className="form-control"
                      name="email"
                      component={InputText}
                      fieldType="text"
                      labelField={t(
                        "forms.provider.forgottenPassword.labels.email"
                      )}
                    />
                  </div>
                </div>

                <div className="row justify-content-center mt-3 mb-4">
                  <div className="col-12 col-md-10 mb-2 text-center">
                    {/* <div className="d-grid gap-4"> */}

                    <button
                      type="submit"
                      className="btn btn-lg btn-primary btn-block"
                    >
                      {t("forms.provider.forgottenPassword.buttons.send")}
                    </button>
                  </div>
                  <div className="col-12 col-md-10 text-center">
                    <button
                      type="button"
                      className="btn btn-lg btn-primary btn-block"
                      onClick={() => onBack()}
                    >
                      {t("forms.provider.forgottenPassword.buttons.back")}
                    </button>
                    {/* </div> */}
                  </div>
                </div>
                <div className="row mt-4"></div>
              </form>
            </ContainerForm>
          </div>
          <div className="col-2"></div>
        </Container>
      </div>
    </div>
  );
};

ForgotPWForm.propTypes = {
  handleSubmit: PropTypes.func,
  gotoLogin: PropTypes.func,
};

const ForgotPWFormF = withFormik({
  mapPropsToValues: () => dataModel,
  validationSchema: validationDataModel,
  handleSubmit: (values, { props }) => {
    props.onSubmit(values);
  },

  displayName: "ForgotPWForm",
})(ForgotPWForm);

export default ForgotPWFormF;
